<template>
  <div class="engine-select">
    <el-popover placement="top" :width="isMobile ? 256 : 400" popper-class="engine-select-popover" :visible-arrow="false">
      <div class="engine-select-trigger" slot="reference">
        <div class="icons" :class="{ fold: currentEngineList.length > 3}">
            <div class="icon-item" v-for="item in currentEngineList" :key="item.value">
              <img :src="item.icon" :title="item.name">  
              <span class="text" v-if="currentEngineList.length == 1">{{ item.value === 'suno' ? 'Suno V3' : item.name }}</span> 
              <div class="mode" v-if="isMobile && currentEngineList.length == 1 && item.value === 'gpt-4'">
                <img src="@/assets/images/new/icon_web1.svg" v-if="webMode">
                <img src="@/assets/images/new/icon_enhance1.svg" v-if="enhanceMode">
              </div>  
            </div>   
        </div>
        <span class="text" v-if="!currentEngineList.length">请选择AI</span>
        <i class="el-icon-arrow-up"></i>
      </div>
      <div class="engine-select-content">
        <div
          class="engine-select-item"
          v-for="item in engineList"
          :key="item.value"
          :class="{
            active: isActive(item),
            disabled: isDisabled(item),
          }"
          @click="changeEngine(item)"
        >
          <img :src="item.icon" />
          <span class="name">{{ item.name }}</span>
          <span class="version" v-if="!isMobile">版本：{{ item.version }}</span>
            <span class="check"><i class="el-icon-check"></i></span>
        </div>
      </div>
    </el-popover>
  </div>
</template>

<script>
import { engineList, engineValueList, engineSingleValueList } from "@/constants";

export default {
  props: {
    value: [String, Array],
    multiple: Boolean,
    webMode: Number,
    enhanceMode: Number,
    docNum: Number,
    imageNum: Number
  },
  data() {
    return {
      currentEngine: this.$props.value,
      engineSingleValueList,
      engineValueList,
      engineList
    };
  },
  computed: {
    currentEngineList() {
        return this.currentEngine.map(e => {
            return this.engineList.find(item => item.value === e)
        })
    }
  },
  watch: {
    value(val) {
      this.currentEngine = val;
    },
    currentEngine(val) {
      this.$emit("change", val);
    },
    docNum(val) {
      this.currentEngine = this.currentEngine.filter(e => {
        return !this.isDisabled(engineList.find(item => item.value === e))
      })
      if (val) {
        this.currentEngine = ['gpt-4']
      }
      this.$emit("input", this.currentEngine);
    },
    imageNum() {
      this.currentEngine = this.currentEngine.filter(e => {
        return !this.isDisabled(engineList.find(item => item.value === e))
      })
      this.$emit("input", this.currentEngine);
    },
    webMode() {
      this.currentEngine = this.currentEngine.filter(e => {
        return !this.isDisabled(engineList.find(item => item.value === e))
      })
      this.$emit("input", this.currentEngine);
    },
    enhanceMode() {
      this.currentEngine = this.currentEngine.filter(e => {
        return !this.isDisabled(engineList.find(item => item.value === e))
      })
      this.$emit("input", this.currentEngine);
    }
  },
  methods: {
    changeEngine(item) {
      if(this.isDisabled(item)) {
        return
      }
      const val = item.value
      if (this.multiple) {
        if (this.currentEngine.includes(val)) {
          // 取消选中
          this.currentEngine = this.currentEngine.filter(e=> e != val)
        } else {
          // 设置选中，判断是否是dall-e-3
          if (item.single) {
            this.currentEngine = [val]
          } else {
            this.currentEngine = [...this.currentEngine.filter(e=> !this.engineSingleValueList.includes(e)), val]
            this.currentEngine = this.engineValueList.filter(e => this.currentEngine.includes(e))
          }
        }
      } else {
        this.currentEngine = val;
      }
      this.$emit("input", this.currentEngine);
    },
    isActive(item) {
      if (this.multiple) {
        return this.currentEngine.includes(item.value)
      }
      return this.currentEngine === item.value
    },
    isDisabled(item) {
      return (this.docNum && !item.docSupport) || 
             (this.imageNum && !item.imageSupport) || 
             (this.webMode && !item.webMode) ||
             (this.enhanceMode && !item.enhanceMode)
    }
  },
  mounted() {

  },
};
</script>
<style lang="less" scoped>
.engine-select {
    display: inline-block;
    &-trigger {
        display: flex;
        height: 34px;
        align-items: center;
        border-radius: 18px;
        background: linear-gradient(180deg, #EFF0F3 0%, #EEEFF2 100%);
        padding-left: 10px;
        padding-right: 12px;
        cursor: pointer;
        .icons {
            display: flex;
            &.fold {
                .icon-item {
                    margin-right: -10px;
                }
            }
            :last-child {
                margin-right: 0 !important;
            }
        }
        .icon-item {
          height: 22px;
          display: flex;
          align-items: center;
          margin-right: 6px;
        }
        img {
            width: 22px;
            height: 22px;
            margin-right: 6px;
        }
        .el-icon-arrow-up {
            margin-left: 12px;
            color: #989A9D;
        }
        .text {
          color: #76787D;
          font-size: 14px;
        }
        .mode {
          height: 20px;
          margin-left: 5px;
          img {
            margin-right: 0;
          }
        }
    }
    &-content {
      max-height: 260px;
      overflow-y: auto;
    }
    &-item {
    height: 39px;
    border-radius: 6px;
    padding-left: 20px;
    display: flex;
    align-items: center;
    font-size: 13px;
    color: #232C3A;
    cursor: pointer;
    position: relative;
    &:hover {
        background-color: #f3f3f3f3;
    }
    img {
      width: 22px;
      height: 22px;
      flex-shrink: 0;
      margin-right: 10px;
    }
    .version {
      font-size: 12px;
      color: #B3B5B8;
      margin-left: 10px;
    }
    .check {
      position: absolute;
      right: 20px;
      top: 13px;
      width: 14px;
      height: 14px;
      border: 1px solid var(--color-2);
      color: transparent;
      border-radius: 2px;
      line-height: 13px;
      text-align: center;
      font-size: 11px;
    }
    &.active {
      border-color: var(--color-1);
      .check {
        border-color: var(--color-1);
        background-color: var(--color-1);
        color: #fff;
      }
    }
    &.disabled {
      opacity: 0.3;
      cursor: not-allowed;
    }
  }
}
@media only screen and (max-width: 610px) {
  .engine-select {
    &-trigger {
      height: 28px;
      padding: 0 5px;
      .icons {
        margin-right: 5px;
        height: 20px;
      }
      img {
        width: 20px;
        height: 20px;
      }
      .el-icon-arrow-up { 
        margin-left: 0;
      }
    }
  }
}
</style>